const online_config = {
  h5_login: "//club.mgtv.com/usercenter/login.html",
  h5_logout: "//club.mgtv.com/usercenter/logout.html",  
  api_user_info: "//nuc.api.mgtv.com/GetUserInfo",
  api_vip_info: "//as.mgtv.com/client/user/user_info",

  h5_casher: "//club.mgtv.com/usercenter/buyvip.html",
  aphone_casher: "https://app.hitv.com/pay/aphone/index.html",
  iphone_casher: "https://app.hitv.com/pay/iphone/index.html",
  ipad_casher: "https://app.hitv.com/pay/ipad/index.html",
  wx_share:'//club.api.mgtv.com/usercenter/v2/mangoLogin/js'
}

const test_config = Object.assign({}, online_config, {
  h5_login: "//testclub.bz.mgtv.com/usercenter/login.html",
  h5_logout: "//testclub.bz.mgtv.com/usercenter/logout.html",
  api_user_info: "//testclub.api.mgtv.com/usercenter/v2/uc/myInfo",
  h5_casher: "//testclub.bz.mgtv.com/usercenter/buyvip.html"
})


export default {
  online_env: online_config,
  test_env: test_config
}



// WEBPACK FOOTER //
// ./src/constant/config.js